import { MutableRefObject, useEffect, useState } from "react";
import { useResizeDetector } from "react-resize-detector";

export function useCheckWindowRenderTypeRequired(targetRef: MutableRefObject<HTMLElement | null>) {
  const { height } = useResizeDetector({ targetRef, handleWidth: false, handleHeight: true });
  const [ isForcedType, setIsForcedType ] = useState(window.innerHeight <= (height || 0));

  useEffect(() => {
    const handleResize = () => {
      const currHeight = window.innerHeight;
      const threshold = height || 0;
      if (currHeight <= threshold) {
        setIsForcedType(true);
      } else if (currHeight > threshold) {
        setIsForcedType(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [ height ]);

  return isForcedType;
}

export function findParentWithNonStaticPosition(element: HTMLElement | null | undefined) {
  if (!element) return document.body;

  const position = window.getComputedStyle(element).position;
  if (position === "static") {
    return findParentWithNonStaticPosition(element.parentElement);
  }

  return element;
}